export const ACTION_REPORTS = 'actionReports';
export const LEDGERS_MAMBU = 'ledgers/mambu';
